import admin from './admin';
import builder from './builder';
import client from './client';
import country from './country';
import customer from './customer';
import dashboard from './dashboard';
import dev from './dev';
import fpc from './fpc';
import franchise from './franchise';
import job from './job';
import notification from './notification';
import organization from './organization';
import principal from './principal';
import project from './project';
import report from './report';
import team from './team';
import transaction from './transaction';
import user from './user';
import webhook from './webhook';
import wholehouse from './wholehouse';

export const permission = [
	...admin,
	...builder,
	...client,
	...country,
	...customer,
	...dashboard,
	...dev,
	...fpc,
	...franchise,
	...job,
	...notification,
	...organization,
	...principal,
	...project,
	...report,
	...team,
	...transaction,
	...user,
	...webhook,
	...wholehouse,
] as const;
